module.exports = __webpack_public_path__ + "img/일본국기.967477bb.png";